module.exports = __webpack_public_path__ + "9603cb35fea843269cb0bdd305c0aa8e.otf";